<template>
  <div>
    <transition name="el-fade-in-linear">
      <div class="main_wrap" v-show="shown.mainshow">
        <div class="commonhead">
          <com-head></com-head>
        </div>
        <div class="head_wrap"></div>
        <div style="margin-bottom: 2rem; margin-left: 6rem; width: 60rem">
          <el-alert :title="$t('App.page.orderconfirm.notice_modifyadd')" type="success" :closable="false" show-icon
            effect="dark"></el-alert>
        </div>
        <div class="confirm_collapse">
          <el-collapse v-model="pageData.collapseActive" @change="handleCollapseChange">
            <div class="body_wrap">
              <div class="orderconfirm_collapse">
                <el-collapse-item :title="$t('App.page.orderconfirm.address_title')" name="1">
                  <div class="shipping_address">
                    <div class="address_no_result" v-if="pageData.listShippingAddress.length === 0">
                      {{ $t('App.page.orderconfirm.text_no_address') }}
                    </div>
                    <div class="address_body">
                      <el-radio-group v-model="formData.orderForm.shipping_address">
                        <div v-for="(
address, index
                          ) in pageData.listShippingAddress" :key="index" class="div_address">
                          <el-button circle type="primary" class="el-icon-edit" size="mini"
                            @click="editShipping(address)"></el-button>
                          <el-button circle type="primary" class="el-icon-copy-document" size="mini"
                            @click="copyToInvoice(address)"></el-button>
                          <el-tag type="success" size="small" effect="dark" :hit="true">{{ address.tag }}</el-tag>
                          <el-radio :label="address.id" style="margin-left: 1.5rem">{{
                            address.contacts +
                            ', ' +
                            address.email +
                            ', ' +
                            address.tel +
                            ', ' +
                            address.address +
                            ', ' +
                            address.city +
                            ', ' +
                            address.province +
                            ', ' +
                            address.zipcode
                            }}</el-radio>
                        </div>
                      </el-radio-group>
                    </div>
                    <div class="address_add">
                      <div v-if="this.pageData.listShippingAddress.length < 10">
                        <span @click="showNewContent" class="address_link">{{
                          $t('App.page.orderconfirm.address_add')
                        }}</span>
                      </div>
                      <transition name="el-zoom-in-top">
                        <div class="content_newaddress" v-show="shown.newaddshow">
                          <el-col class="col_newitems0">
                            {{ $t('App.page.orderconfirm.title_country')
                            }}<br />
                            <el-select v-model="pageData.newAdd.country" filterable size="mini"
                              :placeholder="$t('App.text.placeholder_select')">
                              <div v-if="pageData.lang == 'cn'">
                                <el-option v-for="(item, index) in pageData.listCountry" :key="index"
                                  :label="item.name_cn" :value="item.id"></el-option>
                              </div>
                              <div v-else>
                                <el-option v-for="(item, index) in pageData.listCountry" :key="index"
                                  :label="item.name_en" :value="item.id"></el-option>
                              </div>
                            </el-select>
                          </el-col>

                          <el-col class="col_newitems1">
                            {{ $t('App.page.orderconfirm.title_province') }}
                            <el-input name="new_province" autocomplete="on" v-model="pageData.newAdd.province"
                              maxlength="20" show-word-limit size="mini"
                              :placeholder="$t('App.text.placeholder')"></el-input>
                          </el-col>

                          <el-col class="col_newitems1">
                            {{ $t('App.page.orderconfirm.title_city') }}
                            <el-input name="new_city" autocomplete="on" v-model="pageData.newAdd.city" maxlength="50"
                              show-word-limit size="mini" :placeholder="$t('App.text.placeholder')"></el-input>
                          </el-col>

                          <el-col class="col_newitems_add">
                            {{ $t('App.page.orderconfirm.title_detailadd') }}
                            <el-input name="new_address" autocomplete="on" v-model="pageData.newAdd.address"
                              maxlength="50" show-word-limit size="mini"
                              :placeholder="$t('App.text.placeholder')"></el-input>
                          </el-col>

                          <el-col class="col_newitems1">
                            {{ $t('App.page.orderconfirm.title_zipcode') }}
                            <el-input name="new_zipcode" autocomplete="on" v-model="pageData.newAdd.zipcode"
                              maxlength="20" show-word-limit size="mini"
                              :placeholder="$t('App.text.placeholder')"></el-input>
                          </el-col>

                          <el-col>
                            <el-col class="col_newitems1">
                              {{ $t('App.page.orderconfirm.title_contacts') }}
                              <el-input name="new_contacts" autocomplete="on" v-model="pageData.newAdd.contacts"
                                maxlength="30" show-word-limit size="mini"
                                :placeholder="$t('App.text.placeholder')"></el-input>
                            </el-col>

                            <el-col class="col_newitems1">
                              {{ $t('App.page.orderconfirm.title_tel') }}
                              <el-input name="new_tel" autocomplete="on" v-model="pageData.newAdd.tel" maxlength="30"
                                show-word-limit size="mini" :placeholder="$t('App.text.placeholder')"></el-input>
                            </el-col>
                          </el-col>

                          <el-col>
                            <el-col class="col_newitems2">
                              {{ $t('App.page.orderconfirm.title_email') }}
                              <el-input name="new_email" autocomplete="on" v-model="pageData.newAdd.email"
                                maxlength="100" show-word-limit size="mini"
                                :placeholder="$t('App.text.placeholder')"></el-input>
                            </el-col>

                            <el-col class="col_newitems2">
                              {{ $t('App.page.orderconfirm.title_tag') }}
                              <el-input name="new_tag" autocomplete="on" v-model="pageData.newAdd.tag" maxlength="13"
                                show-word-limit size="mini" :placeholder="$t('App.text.placeholder_tag_shippingadd')
                                  "></el-input>
                            </el-col>
                          </el-col>

                          <el-col class="col_btn">
                            <el-button type="primary" size="mini" @click="addShippingAddress">{{
                              $t('App.page.orderconfirm.btn_newadd')
                              }}</el-button>
                          </el-col>
                        </div>
                      </transition>
                    </div>
                  </div>
                </el-collapse-item>

                <el-collapse-item :title="$t('App.page.orderconfirm.receipt_title')" name="2">
                  <div class="receipt_address">
                    <div class="address_no_result" v-if="pageData.listReceiptAddress.length === 0">
                      {{ $t('App.page.orderconfirm.text_no_address') }}
                    </div>
                    <div class="address_body">
                      <el-radio-group v-model="formData.orderForm.receipt_address">
                        <div v-for="(
address, index
                          ) in pageData.listReceiptAddress" :key="index" class="div_address">
                          <el-button circle type="primary" class="el-icon-edit" size="mini"
                            @click="editReceipt(address)"></el-button>
                          <el-tag effect="dark" size="small" type="warning" :hit="true">{{ address.tag }}</el-tag>
                          <el-radio :label="address.id" style="margin-left: 1.5rem">{{
                            address.contacts +
                            ', ' +
                            address.company +
                            ',' +
                            address.email +
                            ', ' +
                            address.tel +
                            ', ' +
                            address.address +
                            ', ' +
                            address.city +
                            ', ' +
                            address.province +
                            ', ' +
                            address.zipcode +
                            ', ' +
                            address.taxno
                            }}</el-radio>
                        </div>
                      </el-radio-group>
                    </div>
                    <div class="address_add">
                      <div v-if="this.pageData.listReceiptAddress.length < 10">
                        <span @click="showNewContent_receipt" class="address_link">{{
                          $t('App.page.orderconfirm.address_add') }}</span>
                      </div>
                      <transition name="el-zoom-in-top">
                        <div class="content_newaddress" v-show="shown.newaddshow_receipt">
                          <el-col class="col_newitems0">
                            {{ $t('App.page.orderconfirm.title_country')
                            }}<br />
                            <el-select v-model="pageData.newAdd_receipt.country" filterable size="mini"
                              :placeholder="$t('App.text.placeholder_select')">
                              <div v-if="pageData.lang == 'cn'">
                                <el-option v-for="(item, index) in pageData.listCountry" :key="index"
                                  :label="item.name_cn" :value="item.id"></el-option>
                              </div>
                              <div v-else>
                                <el-option v-for="(item, index) in pageData.listCountry" :key="index"
                                  :label="item.name_en" :value="item.id"></el-option>
                              </div>
                            </el-select>
                          </el-col>

                          <el-col class="col_newitems1">
                            {{ $t('App.page.orderconfirm.title_province') }}
                            <el-input name="new_province2" autocomplete="on" v-model="pageData.newAdd_receipt.province"
                              maxlength="20" show-word-limit size="mini"
                              :placeholder="$t('App.text.placeholder')"></el-input>
                          </el-col>

                          <el-col class="col_newitems1">
                            {{ $t('App.page.orderconfirm.title_city') }}
                            <el-input name="new_city2" autocomplete="on" v-model="pageData.newAdd_receipt.city"
                              maxlength="50" show-word-limit size="mini"
                              :placeholder="$t('App.text.placeholder')"></el-input>
                          </el-col>

                          <el-col class="col_newitems_add">
                            {{ $t('App.page.orderconfirm.title_detailadd') }}
                            <el-input name="new_address2" autocomplete="on" v-model="pageData.newAdd_receipt.address"
                              maxlength="50" show-word-limit size="mini"
                              :placeholder="$t('App.text.placeholder')"></el-input>
                          </el-col>

                          <el-col class="col_newitems1">
                            {{ $t('App.page.orderconfirm.title_zipcode') }}
                            <el-input name="new_zipcode2" autocomplete="on" v-model="pageData.newAdd_receipt.zipcode"
                              maxlength="20" show-word-limit size="mini"
                              :placeholder="$t('App.text.placeholder')"></el-input>
                          </el-col>

                          <el-col>
                            <el-col class="col_newitems1">
                              {{ $t('App.page.orderconfirm.title_contacts') }}
                              <el-input name="new_contacts2" autocomplete="on"
                                v-model="pageData.newAdd_receipt.contacts" maxlength="30" show-word-limit size="mini"
                                :placeholder="$t('App.text.placeholder')"></el-input>
                            </el-col>

                            <el-col class="col_newitems1">
                              {{ $t('App.page.orderconfirm.title_company') }}
                              <el-input name="new_company2" autocomplete="on" v-model="pageData.newAdd_receipt.company"
                                maxlength="100" show-word-limit size="mini"
                                :placeholder="$t('App.text.placeholder')"></el-input>
                            </el-col>

                            <el-col class="col_newitems1">
                              {{ $t('App.page.orderconfirm.title_tel') }}
                              <el-input name="new_tel2" autocomplete="on" v-model="pageData.newAdd_receipt.tel"
                                maxlength="30" show-word-limit size="mini"
                                :placeholder="$t('App.text.placeholder')"></el-input>
                            </el-col>
                          </el-col>

                          <el-col>
                            <el-col class="col_newitems2">
                              {{ $t('App.page.orderconfirm.title_email') }}
                              <el-input name="new_email2" autocomplete="on" v-model="pageData.newAdd_receipt.email"
                                maxlength="100" show-word-limit size="mini"
                                :placeholder="$t('App.text.placeholder')"></el-input>
                            </el-col>

                            <el-col class="col_newitems2">
                              {{ $t('App.page.orderconfirm.title_taxno') }}
                              <el-input name="new_taxno2" autocomplete="on" v-model="pageData.newAdd_receipt.taxno"
                                maxlength="15" show-word-limit size="mini"
                                :placeholder="$t('App.text.placeholder')"></el-input>
                            </el-col>

                            <el-col class="col_newitems2">
                              {{ $t('App.page.orderconfirm.title_tag') }}
                              <el-input name="new_tag2" autocomplete="on" v-model="pageData.newAdd_receipt.tag"
                                maxlength="13" show-word-limit size="mini" :placeholder="$t('App.text.placeholder_tag_shippingadd')
                                  "></el-input>
                            </el-col>
                          </el-col>

                          <el-col class="col_btn">
                            <el-button type="primary" size="mini" @click="addReceiptAddress">{{
                              $t('App.page.orderconfirm.btn_newadd')
                              }}</el-button>
                          </el-col>
                        </div>
                      </transition>
                    </div>
                  </div>
                </el-collapse-item>

                <el-collapse-item :title="$t('App.page.orderconfirm.delivery_title')" name="3">
                  <div class="delivery_terms">
                    <div class="delivery_items">
                      <el-radio-group size="mini" v-model="formData.orderForm.delivery_terms">
                        <el-tooltip class="item" effect="dark" :content="$t('App.page.orderconfirm.notify_delivery_a')
                          " placement="top">
                          <el-radio-button :label="pageData.deliveryterms.a">{{
                            $t('App.page.orderconfirm.radio_delivery_a')
                          }}</el-radio-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" :content="$t('App.page.orderconfirm.notify_delivery_b')
                          " placement="top">
                          <el-radio-button :label="pageData.deliveryterms.b">{{
                            $t('App.page.orderconfirm.radio_delivery_b')
                          }}</el-radio-button>
                        </el-tooltip>
                      </el-radio-group>
                    </div>
                  </div>
                </el-collapse-item>

                <el-collapse-item :title="$t('App.page.orderconfirm.payment_title')" name="4">
                  <div class="payment_terms">
                    <div class="payment_items">
                      <el-alert :title="pageData.explain" type="success" effect="dark" :closable="false" show-icon
                        style="width: 18rem">
                      </el-alert>
                    </div>
                  </div>
                </el-collapse-item>

                <el-collapse-item :title="$t('App.page.orderconfirm.details_title')" name="5">
                  <div class="order_details">
                    <div class="details_table">
                      <el-card shadow="hover">
                        <!-- 产品购物详情 -->
                        <el-table border ref="detailsTable" show-summary :data="pageData.orderDetails"
                          tooltip-effect="dark" @selection-change="detailsSelectedChange" :header-cell-style="{
                            textAlign: 'center',
                            backgroundColor: '#f2f6fc',
                          }" :cell-style="{ textAlign: 'center' }">
                          <el-table-column type="index" width="70">
                          </el-table-column>
                          <el-table-column :label="this.$t('App.page.cart.productimage')" width="150">
                            <template slot-scope="scope">
                              <!-- <el-image
                                :src="'data:image/jpg;base64,' + scope.row.img"
                              >
                                <div slot="placeholder" class="image-slot">
                                  {{ $t('App.text.loading') }}
                                </div>
                              </el-image> -->
                              <el-image v-if="
                                scope.row &&
                                scope.row.img &&
                                scope.row.img.length > 0
                              " :src="formatProductImage(scope.row.img)" /> </template></el-table-column>

                          <el-table-column :label="this.$t('App.page.cart.productname')">
                            <template slot-scope="scope">{{
                              scope.row.productname
                            }}</template>
                          </el-table-column>

                          <el-table-column :label="this.$t('App.page.cart.productprice')">
                            <template slot-scope="scope">{{ scope.row.sign
                              }}{{
                                Number(scope.row.uniprice).toFixed(2)
                              }}</template>
                          </el-table-column>

                          <el-table-column :label="this.$t('App.page.cart.productdiscount')"
                            v-if="pageData.orderDetails.some(it => !it.new_price)">
                            <template slot-scope="scope">
                              <span v-if="scope.row.new_price"></span>
                              <span v-else>{{
                                Number(scope.row.scount * 100).toFixed()
                                }}%</span>
                            </template>
                          </el-table-column>

                          <el-table-column :label="this.$t('App.page.cart.productdisprice')"
                            v-if="pageData.orderDetails.some(it => !it.new_price)">
                            <template slot-scope="scope">
                              {{ scope.row.sign
                              }}{{ Number(scope.row.disprice).toFixed(2) }}
                            </template>
                          </el-table-column>

                          <!-- 显示阶梯 -->
                          <el-table-column :label="this.$t('App.page.cart.ladderRange')" width="350" key="ladderRange"
                            v-if="pageData.orderDetails.some(it => it.new_price)">
                            <template slot-scope="scope">
                              <el-steps :active="scope.row.stepActive" align-center finish-status="wait"
                                process-status="finish" v-if="
                                  pageData.ladderData &&
                                  pageData.ladderData[scope.row.productid] &&
                                  scope.row.new_price
                                ">
                                <el-step v-for="(it, index) in pageData.ladderData[
                                  scope.row.productid
                                ]" :key="it.title" :title="it.title" :icon="index == scope.row.stepActive
                                  ? 'el-icon-circle-check'
                                  : 'el-icon-circle-close'
                                  ">
                                  <template slot="description">
                                    <div class="step_description">
                                      {{ scope.row.sign }}{{ it.price }}
                                    </div>
                                  </template>
                                  <template slot="title">
                                    <div class="step_title">
                                      {{ it.title }}
                                    </div>
                                  </template>
                                  <template slot="icon">
                                    <div class="step_icon">
                                      <i :class="index == scope.row.stepActive
                                        ? 'el-icon-circle-check'
                                        : 'el-icon-circle-close'
                                        "></i>
                                    </div>
                                  </template>
                                </el-step>
                              </el-steps>
                            </template>
                          </el-table-column>

                          <!-- 优惠价 -->
                          <!-- <el-table-column :label="this.$t('App.page.cart.ladderPrice')" prop="ladderPrice"
                            key="ladderPrice" v-if="pageData.custUserinfo.new_price">
                            <template slot-scope="scope">
                              {{ scope.row.sign
                              }}{{
                                scope.row.ladderPrice &&
                                Number(scope.row.ladderPrice).toFixed(2)
                              }}
                            </template>
                          </el-table-column> -->

                          <el-table-column prop="quantity" :label="this.$t('App.page.cart.productquantity')"
                            width="160">
                            <template slot-scope="scope">
                              <el-input-number :min="1" :max="9999" size="mini" v-model="scope.row.quantity"
                                @change="refreshSub(scope.row)"></el-input-number></template>
                          </el-table-column>

                          <el-table-column prop="subprice" :label="this.$t('App.page.cart.productsubprice')">
                            <template slot-scope="scope">{{ scope.row.sign
                              }}{{
                                Number(scope.row.subprice).toFixed(2)
                              }}</template>
                          </el-table-column>

                          <el-table-column :label="this.$t('App.page.cart.productoption')">
                            <template slot-scope="scope">
                              <el-button type="danger" circle size="mini" icon="el-icon-delete"
                                @click="deleteRow(scope.$index, scope.row)"></el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-card>
                    </div>
                    <div class="details_customerpo">
                      <el-col style="text-align: left; color: #606266">{{
                        $t('App.page.orderconfirm.title_customer_po')
                      }}</el-col>
                      <el-input maxlength="50" size="small" show-word-limit v-model="formData.orderForm.cust_no">
                      </el-input>
                    </div>
                    <div class="details_notes">
                      <el-col style="text-align: left; color: #606266">{{
                        $t('App.page.orderconfirm.title_notes')
                      }}</el-col>
                      <el-input type="textarea" maxlength="240" show-word-limit
                        :placeholder="$t('App.text.placeholder_notes')" v-model="formData.orderForm.notes"
                        :autosize="{ minRows: 5 }"></el-input>
                    </div>
                  </div>
                </el-collapse-item>
              </div>
              <div class="items_opt">
                <div class="details_domain" v-if="this.pageData.orderDetails !== undefined">
                  <span style="
                      color: #303133;
                      font-size: 1rem;
                      vertical-align: middle;
                    ">{{ $t('App.page.cart.text_total') }} </span><span
                    style="color: red; font-size: 1rem; vertical-align: middle"
                    v-if="this.formData.orderForm.total === 0 ? false : true"><span style="font-size: 0.9rem">{{
                      this.formData.orderForm.sign
                    }}</span>{{
                        Number(this.formData.orderForm.total).toFixed(2)
                      }}</span>
                  <span style="
                      color: #303133;
                      font-size: 1rem;

                      vertical-align: middle;
                    ">{{ $t('App.page.cart.text_weight') }}</span>
                  <span style="color: red; font-size: 1rem; vertical-align: middle">{{
                    Number(this.formData.orderForm.totalWeight).toFixed(2)
                  }}{{ $t('App.text.kg_abbr') }}</span>
                  <div style="margin-top: 1.5rem">
                    <span v-if="
                      formData.orderForm.total <
                      pageData.custUserinfo.minamount ||
                      formData.orderForm.totalWeight <
                      pageData.custUserinfo.minweight
                    " style="font-size: 0.9rem; color: #f56c6c">{{
                      $t('App.page.orderconfirm.tooltip_mintotal_weight')
                    }}</span>
                    <el-button type="success" size="small" @click="duSubmit" :disabled="pageData.quantityDisabled ||
                      formData.orderForm.total <
                      pageData.custUserinfo.minamount ||
                      formData.orderForm.totalWeight <
                      pageData.custUserinfo.minweight
                      " :loading="pageData.submitLoad" v-loading.fullscreen.lock="pageData.fullScreenLoad">{{
                        $t('App.page.orderconfirm.btn_submit') }}</el-button>
                  </div>
                </div>
              </div>
              <div class="questionnaire_content">
                <div class="feedback_popover">
                  <el-dialog width="70%" ref="feedback_dialog" :modal="true" :show-close="true"
                    :close-on-click-modal="false" :close-on-press-escape="false" :center="true"
                    :title="this.$t('App.page.orderconfirm.title_feedback')"
                    :visible.sync="pageData.feedbackDialogVisible">
                    <el-alert type="success" :description="this.$t('App.page.orderconfirm.tip_feedback')
                      " show-icon :closable="false">
                    </el-alert>

                    <el-form :model="formData.feedbackForm" ref="form_feedback" class="form_feedback" size="mini">
                      <el-form-item>
                        <p class="question_style">
                          {{ this.pageData.questionList[0].sort + 1 }}.{{
                            this.pageData.questionList[0].content_en
                          }}
                        </p>
                        <el-radio-group v-model="formData.feedbackForm.results[0].score" size="medium">
                          <el-radio-button v-for="(item, index) in 10" :index="index + 1" :key="index + 1"
                            :label="index + 1"></el-radio-button>
                        </el-radio-group>
                      </el-form-item>

                      <el-form-item>
                        <p class="question_style">
                          {{ this.pageData.questionList[1].sort + 1 }}.{{
                            this.pageData.questionList[1].content_en
                          }}
                        </p>
                        <el-radio-group v-model="formData.feedbackForm.results[1].score" size="medium">
                          <el-radio v-for="(item, index) in this.pageData
                            .questionList[1].items" :label="item.score" :key="index">{{ item.context }}</el-radio>
                        </el-radio-group>
                        <div>
                          <p class="why_style">
                            {{ $t('App.page.orderconfirm.why') }}
                          </p>
                          <el-input type="textarea" v-model="formData.feedbackForm.results[1].reason" maxlength="240"
                            show-word-limit :placeholder="$t('App.text.placeholder_notes')"
                            :autosize="{ minRows: 2 }"></el-input>
                        </div>
                      </el-form-item>

                      <el-form-item>
                        <p class="question_style">
                          {{ this.pageData.questionList[2].sort + 1 }}.{{
                            this.pageData.questionList[2].content_en
                          }}
                        </p>
                        <p>
                          <el-radio-group v-model="pageData.question3[0].score" size="medium">
                            <el-radio-button label="Reliable"></el-radio-button>
                            <el-radio-button label="Unreliable"></el-radio-button>
                          </el-radio-group>
                        </p>
                        <p>
                          <el-radio-group v-model="pageData.question3[1].score" size="medium">
                            <el-radio-button label="High quality"></el-radio-button>
                            <el-radio-button label="Poor quality"></el-radio-button>
                          </el-radio-group>
                        </p>
                        <p>
                          <el-radio-group v-model="pageData.question3[2].score" size="medium">
                            <el-radio-button label="Overpriced"></el-radio-button>
                            <el-radio-button label="Good value for money"></el-radio-button>
                          </el-radio-group>
                        </p>
                        <p>
                          <el-radio-group v-model="pageData.question3[3].score" size="medium">
                            <el-radio-button label="Unique"></el-radio-button>
                            <el-radio-button label="Impractical"></el-radio-button>
                          </el-radio-group>
                        </p>
                        <p>
                          <el-radio-group v-model="pageData.question3[4].score" size="medium">
                            <el-radio-button label="Useful"></el-radio-button>
                            <el-radio-button label="Ineffective"></el-radio-button>
                          </el-radio-group>
                        </p>
                      </el-form-item>

                      <el-form-item v-for="(
question, index
                        ) in this.pageData.questionList.slice(3, 10)" :key="index">
                        <p class="question_style">
                          {{ question.sort + 1 }}.{{ question.content_en }}
                        </p>
                        <el-radio-group v-model="formData.feedbackForm.results[question.sort].score
                          " size="medium">
                          <el-radio v-for="(item, index) in question.items" :label="item.score" :key="index">{{
                            item.context
                          }}</el-radio>
                        </el-radio-group>
                        <div>
                          <p class="why_style">
                            {{ $t('App.page.orderconfirm.why') }}
                          </p>
                          <el-input type="textarea" v-model="formData.feedbackForm.results[question.sort]
                            .reason
                            " maxlength="240" show-word-limit :placeholder="$t('App.text.placeholder_notes')"
                            :autosize="{ minRows: 2 }"></el-input>
                        </div>
                      </el-form-item>

                      <el-form-item>
                        <p class="question_style">
                          {{ this.pageData.questionList[10].sort + 1 }}.{{
                            this.pageData.questionList[10].content_en
                          }}
                        </p>
                        <el-input type="textarea" v-model="formData.feedbackForm.results[10].reason" maxlength="240"
                          show-word-limit :placeholder="$t('App.text.placeholder_notes')"
                          :autosize="{ minRows: 2 }"></el-input>
                      </el-form-item>

                      <el-form-item>
                        <el-button type="success" size="medium" style="float: right; margin-top: 1rem"
                          @click="submitQuestions" :loading="pageData.submitQuestionsFlag">{{ $t('App.text.submit')
                          }}</el-button>
                      </el-form-item>
                    </el-form>
                  </el-dialog>
                </div>
              </div>
            </div>
          </el-collapse>
        </div>
        <div class="foot_wrap">
          <div class="edit_content">
            <div class="shipping_e_content">
              <el-dialog ref="editShipping_Dialog" :modal="true" :close-on-click-modal="false"
                :close-on-press-escape="false" :center="true" :title="this.$t('App.view.customer.title_edit_address')"
                :visible.sync="pageData.editShippingDialogVisible">
                <el-form :model="forms.editShipping" ref="form_editShipping" class="form_editShipping" size="mini">
                  <el-form-item :label="this.$t('App.view.customer.label_country')">
                    <el-col>
                      <el-select v-model="forms.editShipping.country" filterable size="small" style="width: 100%"
                        :placeholder="$t('App.text.placeholder_select')">
                        <div v-if="pageData.lang == 'cn'">
                          <el-option v-for="(item, index) in pageData.listCountry" :key="index" :label="item.name_cn"
                            :value="item.id"></el-option>
                        </div>
                        <div v-else>
                          <el-option v-for="(item, index) in pageData.listCountry" :key="index" :label="item.name_en"
                            :value="item.id"></el-option>
                        </div>
                      </el-select>
                    </el-col>
                  </el-form-item>

                  <el-form-item :label="this.$t('App.view.customer.label_province')">
                    <el-input name="edit_province" autocomplete="on" v-model="forms.editShipping.province"
                      maxlength="20" show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>

                  <el-form-item :label="this.$t('App.view.customer.label_city')">
                    <el-input name="edit_city" autocomplete="on" v-model="forms.editShipping.city" maxlength="50"
                      show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>

                  <el-form-item :label="this.$t('App.view.customer.label_address')">
                    <el-input name="edit_address" autocomplete="on" v-model="forms.editShipping.address" maxlength="50"
                      show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>

                  <el-form-item :label="this.$t('App.view.customer.label_zipcode')">
                    <el-input name="edit_zipcode" autocomplete="on" v-model="forms.editShipping.zipcode" maxlength="50"
                      show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>

                  <el-form-item :label="this.$t('App.view.customer.label_contacts')">
                    <el-input name="edit_contacts" autocomplete="on" v-model="forms.editShipping.contacts"
                      maxlength="30" show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>
                  <el-form-item :label="this.$t('App.view.customer.label_company')">
                    <el-input name="edit_company" autocomplete="on" v-model="forms.editShipping.company" maxlength="100"
                      show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>
                  <el-form-item :label="this.$t('App.view.customer.label_add_tel')">
                    <el-input name="edit_tel" autocomplete="on" v-model="forms.editShipping.tel" maxlength="30"
                      show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>
                  <el-form-item :label="this.$t('App.view.customer.label_add_email')">
                    <el-input name="edit_email" autocomplete="on" v-model="forms.editShipping.email" maxlength="100"
                      show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>
                  <el-form-item :label="this.$t('App.view.customer.label_tag')">
                    <el-input name="edit_tag" autocomplete="on" v-model="forms.editShipping.tag" maxlength="13"
                      show-word-limit size="small" :placeholder="$t('App.text.placeholder_tag_shippingadd')"></el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button class="addAddressBtn" type="success" size="small"
                      @click="useJsDoEditShipping(forms.editShipping)" :loading="pageData.doEditShippingLoad">
                      {{ $t('App.view.customer.btn_save') }}</el-button>
                  </el-form-item>
                </el-form>
              </el-dialog>
            </div>
            <div class="receipt_e_content">
              <el-dialog ref="editReceipt_Dialog" :modal="true" :close-on-click-modal="false"
                :close-on-press-escape="false" :center="true" :title="this.$t('App.view.customer.title_edit_address')"
                :visible.sync="pageData.editReceiptDialogVisible">
                <el-form :model="forms.editReceipt" ref="form_editReceipt" class="form_editReceipt" size="mini">
                  <el-form-item :label="this.$t('App.view.customer.label_country')">
                    <el-col>
                      <el-select v-model="forms.editReceipt.country" filterable size="small" style="width: 100%"
                        :placeholder="$t('App.text.placeholder_select')">
                        <div v-if="pageData.lang == 'cn'">
                          <el-option v-for="(item, index) in pageData.listCountry" :key="index" :label="item.name_cn"
                            :value="item.id"></el-option>
                        </div>
                        <div v-else>
                          <el-option v-for="(item, index) in pageData.listCountry" :key="index" :label="item.name_en"
                            :value="item.id"></el-option>
                        </div>
                      </el-select>
                    </el-col>
                  </el-form-item>

                  <el-form-item :label="this.$t('App.view.customer.label_province')">
                    <el-input name="edit_province2" autocomplete="on" v-model="forms.editReceipt.province"
                      maxlength="20" show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>

                  <el-form-item :label="this.$t('App.view.customer.label_city')">
                    <el-input name="edit_city2" autocomplete="on" v-model="forms.editReceipt.city" maxlength="50"
                      show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>

                  <el-form-item :label="this.$t('App.view.customer.label_address')">
                    <el-input name="edit_address2" autocomplete="on" v-model="forms.editReceipt.address" maxlength="50"
                      show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>

                  <el-form-item :label="this.$t('App.view.customer.label_zipcode')">
                    <el-input name="edit_zipcode2" autocomplete="on" v-model="forms.editReceipt.zipcode" maxlength="20"
                      show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>

                  <el-form-item :label="this.$t('App.view.customer.label_contacts')">
                    <el-input name="edit_contacts2" autocomplete="on" v-model="forms.editReceipt.contacts"
                      maxlength="30" show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>
                  <el-form-item :label="this.$t('App.view.customer.label_company')">
                    <el-input name="edit_company2" autocomplete="on" v-model="forms.editReceipt.company" maxlength="100"
                      show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>
                  <el-form-item :label="this.$t('App.view.customer.label_add_tel')">
                    <el-input name="edit_tel2" autocomplete="on" v-model="forms.editReceipt.tel" maxlength="30"
                      show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>
                  <el-form-item :label="this.$t('App.view.customer.label_add_email')">
                    <el-input name="edit_email2" autocomplete="on" v-model="forms.editReceipt.email" maxlength="100"
                      show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>
                  <el-form-item :label="this.$t('App.view.customer.label_taxno')">
                    <el-input name="edit_taxno2" autocomplete="on" v-model="forms.editReceipt.taxno" maxlength="15"
                      show-word-limit size="small" :placeholder="$t('App.text.placeholder')"></el-input>
                  </el-form-item>
                  <el-form-item :label="this.$t('App.view.customer.label_tag')">
                    <el-input name="edit_tag2" autocomplete="on" v-model="forms.editReceipt.tag" maxlength="13"
                      show-word-limit size="small" :placeholder="$t('App.text.placeholder_tag_shippingadd')"></el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button class="addAddressBtn" type="success" size="small"
                      @click="useJsDoEditReceipt(forms.editReceipt)" :loading="pageData.doEditReceiptLoad">
                      {{ $t('App.view.customer.btn_save') }}</el-button>
                  </el-form-item>
                </el-form>
              </el-dialog>
            </div>
          </div>
          <com-foot></com-foot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Head from '@/components/customer/customerCommonHeader'
import Foot from '@/components/customer/customerCommonFooter'
import * as commonjs from '@/assets/js/common'
import * as orderconfirmjs from '@/assets/js/orderconfirm'
import * as verifyjs from '@/assets/js/verify'
import * as cartjs from '@/assets/js/cart'
import * as centerjs from '@/assets/js/center'
export default {
  data() {
    return {
      api: '',
      shown: {
        mainshow: false,
        newaddshow: false,
        newaddshow_receipt: false,
      },
      pageData: {
        username: '',
        lang: '',
        custUserinfo: {},
        listCountry: [],
        listShippingAddress: [],
        listReceiptAddress: [],
        questionList: [
          { sort: 0 },
          { sort: 0 },
          { sort: 0 },
          { sort: 0 },
          { sort: 0 },
          { sort: 0 },
          { sort: 0 },
          { sort: 0 },
          { sort: 0 },
          { sort: 0 },
          { sort: 0 },
        ],
        explain: '',
        orderDetails: [],
        collapseActive: ['1', '2', '3', '4', '5'],
        orderSelected: [],
        newAdd: {
          username: '',
          country: '',
          province: '',
          city: '',
          zipcode: '',
          address: '',
          contacts: '',
          tel: '',
          email: '',
          tag: '',
        },
        newAdd_receipt: {
          username: '',
          country: '',
          province: '',
          city: '',
          zipcode: '',
          address: '',
          company: '',
          contacts: '',
          tel: '',
          email: '',
          taxno: '',
          tag: '',
        },
        deliveryterms: {
          a: 'a',
          b: 'b',
        },
        submitLoad: false,
        fullScreenLoad: false,
        quantityDisabled: false,
        feedbackDialogVisible: true,
        submitQuestionsFlag: false,
        question3: [
          { score: '' },
          { score: '' },
          { score: '' },
          { score: '' },
          { score: '' },
        ],
        editShippingDialogVisible: false,
        oldShipping: '',
        doEditShippingLoad: false,
        editReceiptDialogVisible: false,
        oldReceipt: '',
        doEditReceiptLoad: false,
      },
      forms: {
        editShipping: {
          id: '',
          username: '',
          country: '',
          province: '',
          city: '',
          zipcode: '',
          address: '',
          company: '',
          contacts: '',
          tel: '',
          email: '',
          tag: '',
        },
        editReceipt: {
          id: '',
          username: '',
          country: '',
          province: '',
          city: '',
          zipcode: '',
          address: '',
          company: '',
          contacts: '',
          tel: '',
          email: '',
          taxno: '',
          tag: '',
        },
      },
      formData: {
        orderForm: {
          shipping_address: '',
          receipt_address: '',
          delivery_terms: '',
          listOrderdetails: [],
          sign: '',
          oritotal: 0,
          total: 0,
          totalWeight: 0,
          cust_no: '',
          notes: '',
        },
        feedbackForm: {
          results: [
            {
              score: null,
              reason: '-',
            },
            {
              score: null,
              reason: '-',
            },
            {
              score: null,
              reason: '',
            },
            {
              score: null,
              reason: '-',
            },
            {
              score: null,
              reason: '-',
            },
            {
              score: null,
              reason: '-',
            },
            {
              score: null,
              reason: '-',
            },
            {
              score: null,
              reason: '-',
            },
            {
              score: null,
              reason: '-',
            },
            {
              score: null,
              reason: '-',
            },
            {
              score: null,
              reason: '-',
            },
          ],
        },
      },
    }
  },
  created() {
    this.$npg.start()
    this.$npg.inc()
  },
  mounted() {
    this.prepareForMounted()
  },
  methods: {
    prepareForMounted() {
      this.api =
        (window.RUNTIME_CONFIG && window.RUNTIME_CONFIG.API_PREFIX) ||
        process.env.API_PREFIX ||
        ''
      this.$npg.done()
      this.pageData.username = sessionStorage.getItem('username')
      this.pageData.lang = sessionStorage.getItem('lang')
      this.pageData.custUserinfo = JSON.parse(
        sessionStorage.getItem(this.pageData.username),
      )
      if (verifyjs.isMounted(this)) {
        document.title = this.$t('App.title.orderconfirm')
        if (this.pageData.lang == 'cn') {
          this.pageData.explain =
            this.pageData.custUserinfo.paymentterms.explain_bak
        } else {
          this.pageData.explain =
            this.pageData.custUserinfo.paymentterms.explain
        }
        this.pageData.listCountry = JSON.parse(
          sessionStorage.getItem('listCountry'),
        )

        orderconfirmjs.getShippingAddress(this, this.pageData.username)
        orderconfirmjs.getReceiptAddress(this, this.pageData.username)
        if (this.pageData.custUserinfo.region === 0) {
          if (this.pageData.custUserinfo.feedback == 0) {
            orderconfirmjs.queryFeedbackQuestion(this)
          } else {
            this.pageData.feedbackDialogVisible = false
          }
        } else {
          this.pageData.feedbackDialogVisible = false
        }

        this.pageData.orderDetails = this.$route.params.cartItems

        //启动了获取阶梯价格信息
        // if (this.pageData.custUserinfo.new_price) {
        cartjs.getLadderPriceNew(
          this,
          this.pageData.orderDetails,
          JSON.parse(sessionStorage.getItem(this.pageData.username)).currency, this.pageData.username
        )
        // }

        this.formData.orderForm.total = Number(
          this.$route.params.totalPrice,
        ).toFixed(2)
        this.formData.orderForm.totalWeight = this.$route.params.totalWeight
        if (this.pageData.custUserinfo.discount != 1) {
          this.formData.orderForm.oritotal =
            this.$route.params.totalPrice /
            (1 - this.pageData.custUserinfo.discount)
        } else {
          this.formData.orderForm.oritotal = 0
        }
        if (this.pageData.orderDetails == undefined) {
          this.$router.push({ name: 'Cart' })
        } else {
          this.formData.orderForm.sign = sessionStorage.getItem('cust_sign')
        }
        setTimeout(() => {
          this.shown.mainshow = true
        }, 270)
      } else {
        this.$router.push({ name: 'Login' })
      }
    },
    formatProductImage(img) {
      if (!img || img.length === 0) return ''
      // If already base64 or full URL, return as is
      if (img.indexOf('data:image') === 0 || img.indexOf('http') === 0) {
        return img
      }
      // If starts with /images, prepend the product image server URL
      if (img.indexOf('/images') === 0) {
        return (process.env.PRODUCT_IMAGE_URL || '') + img
      }
      // Otherwise, prepend API prefix
      return (this.api || '') + img
    },
    showNewContent() {
      setTimeout(() => {
        this.shown.newaddshow = true
      }, 1)
    },
    showNewContent_receipt() {
      setTimeout(() => {
        this.shown.newaddshow_receipt = true
      }, 1)
    },
    addShippingAddress() {
      if (
        verifyjs.strIsEmpty(this.pageData.newAdd.country) ||
        verifyjs.strIsEmpty(this.pageData.newAdd.province) ||
        verifyjs.strIsEmpty(this.pageData.newAdd.city) ||
        verifyjs.strIsEmpty(this.pageData.newAdd.zipcode) ||
        verifyjs.strIsEmpty(this.pageData.newAdd.address) ||
        verifyjs.strIsEmpty(this.pageData.newAdd.contacts) ||
        verifyjs.strIsEmpty(this.pageData.newAdd.tel) ||
        verifyjs.strIsEmpty(this.pageData.newAdd.email) ||
        verifyjs.strIsEmpty(this.pageData.newAdd.tag)
      ) {
        return
      }

      let regEmail =
        /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,10}$/
      if (!regEmail.test(this.pageData.newAdd.email)) {
        this.$notify.error({
          title: this.$t('App.page.orderconfirm.notify_normal_err_code'),
          message: this.$t('App.page.orderconfirm.notify_email_error'),
        })
        return
      }

      this.pageData.newAdd.username = this.pageData.username
      orderconfirmjs.addShippingAddress(this, this.pageData.newAdd)
    },
    addReceiptAddress() {
      if (
        verifyjs.strIsEmpty(this.pageData.newAdd_receipt.country) ||
        verifyjs.strIsEmpty(this.pageData.newAdd_receipt.province) ||
        verifyjs.strIsEmpty(this.pageData.newAdd_receipt.city) ||
        verifyjs.strIsEmpty(this.pageData.newAdd_receipt.zipcode) ||
        verifyjs.strIsEmpty(this.pageData.newAdd_receipt.address) ||
        verifyjs.strIsEmpty(this.pageData.newAdd_receipt.company) ||
        verifyjs.strIsEmpty(this.pageData.newAdd_receipt.contacts) ||
        verifyjs.strIsEmpty(this.pageData.newAdd_receipt.tel) ||
        verifyjs.strIsEmpty(this.pageData.newAdd_receipt.email) ||
        verifyjs.strIsEmpty(this.pageData.newAdd_receipt.tag)
      ) {
        return
      }

      let regEmail =
        /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,10}$/
      if (!regEmail.test(this.pageData.newAdd_receipt.email)) {
        this.$notify.error({
          title: this.$t('App.page.orderconfirm.notify_normal_err_code'),
          message: this.$t('App.page.orderconfirm.notify_email_error'),
        })
        return
      }

      if (verifyjs.strIsEmpty(this.pageData.newAdd_receipt.taxno)) {
        this.pageData.newAdd_receipt.taxno = '-'
      }

      this.pageData.newAdd_receipt.username = this.pageData.username
      orderconfirmjs.addReceiptAddress(this, this.pageData.newAdd_receipt)
    },
    handleCollapseChange(val) { },
    detailsSelectedChange(val) {
      this.pageData.orderSelected = val
    },
    refreshSub(row) {
      if (verifyjs.strIsEmpty(row.quantity)) {
        this.pageData.quantityDisabled = true
      } else {
        this.pageData.quantityDisabled = false
      }

      this.formData.orderForm.total = 0
      this.formData.orderForm.totalWeight = 0
      row.subprice = row.quantity * row.disprice
      row.newprice = row.stagedPrice

      //启动阶梯，重新算值
      if (row.newprice) {
        row = cartjs.getLadderPriceByProductAndQuantity(this, row)
        row.disprice = row.ladderPrice
      }

      for (let row of this.pageData.orderDetails) {
        this.formData.orderForm.total += Number(row.subprice)
        this.formData.orderForm.totalWeight += row.weight * row.quantity
      }
      if (this.pageData.custUserinfo.discount != 1) {
        this.formData.orderForm.oritotal =
          this.formData.orderForm.total /
          (1 - this.pageData.custUserinfo.discount)
      } else {
        this.formData.orderForm.oritotal = 0
      }
    },
    deleteRow(index, row) {
      this.formData.orderForm.total =
        this.formData.orderForm.total - row.subprice
      this.formData.orderForm.totalWeight =
        this.formData.orderForm.totalWeight - row.weight * row.quantity
      this.pageData.orderDetails.splice(index, 1)
    },
    submitQuestions() {
      for (let item of this.pageData.question3) {
        if (verifyjs.strIsEmpty(item.score)) {
          this.$notify.warning({
            title: this.$t('App.notify.title_nofity'),
            message: this.$t('App.page.orderconfirm.question_unfinished') + 3,
          })
          return
        }
      }

      let arr = []
      for (let item of this.pageData.question3) {
        arr.push(item.score)
      }
      this.formData.feedbackForm.results[2].reason = arr.join()

      this.formData.feedbackForm.results[2].score = 0
      this.formData.feedbackForm.results[10].score = 0

      for (let index in this.formData.feedbackForm.results) {
        if (
          verifyjs.strIsEmpty(
            this.formData.feedbackForm.results[index].score,
          ) ||
          verifyjs.strIsEmpty(this.formData.feedbackForm.results[index].reason)
        ) {
          this.$notify.warning({
            title: this.$t('App.notify.title_nofity'),
            message:
              this.$t('App.page.orderconfirm.question_unfinished') +
              (Number(index) + 1),
          })
          return
        }
      }

      for (let index in this.formData.feedbackForm.results) {
        this.formData.feedbackForm.results[index].customer =
          this.pageData.username
        this.formData.feedbackForm.results[index].question_id =
          this.pageData.questionList[index].id
      }

      orderconfirmjs.postToSaveQuestion(
        this,
        this.formData.feedbackForm.results,
      )
    },
    duSubmit() {
      this.formData.orderForm.listOrderdetails = orderconfirmjs.packDetails(
        this.pageData.orderDetails,
      )

      let subtotalCount = 0
      for (let item of this.formData.orderForm.listOrderdetails) {
        subtotalCount = subtotalCount + Number(item.subtotal)
      }
      console.log(this.formData.orderForm.total, subtotalCount, '总数')
      console.log(
        Number(this.formData.orderForm.total).toFixed(2).split('.')[0],
        Number(subtotalCount).toFixed(2).split('.')[0],
        '总数',
      )
      if (
        Number(this.formData.orderForm.total).toFixed(2).split('.')[0] !=
        Number(subtotalCount).toFixed(2).split('.')[0]
      ) {
        // cartjs.clearCart(this, this.pageData.username)

        this.$notify.error({
          title: this.$t('App.notify.title_warning'),
          message: this.$t('App.page.orderconfirm.quantity_unupdate_error'),
        })
        return
      }

      if (orderconfirmjs.verifyOrder(this, this.formData.orderForm)) {
        this.pageData.submitLoad = true
        this.pageData.fullScreenLoad = true

        orderconfirmjs.getModifiedList(
          this,
          this.formData.orderForm.listOrderdetails,
          this.pageData.custUserinfo.country,
        )
      }
    },
    useJsDoEditShipping(shipping) {
      centerjs.doEditShipping(this, shipping).then((val) => {
        if (val) {
          orderconfirmjs.getShippingAddress(this, this.pageData.username)
        }
      })
    },
    copyToInvoice(shipping) {
      this.$confirm(
        this.$t('App.page.orderconfirm.copyToInvoice_notice'),
        this.$t('App.view.consolesetting.text_saveinfo_title'),
        {
          confirmButtonText: this.$t('App.view.customer.btn_message_confirm'),
          cancelButtonText: this.$t('App.view.customer.btn_message_cancel'),
          type: 'warning',
        },
      )
        .then(() => {
          this.pageData.newAdd_receipt.country = shipping.country
          this.pageData.newAdd_receipt.province = shipping.province
          this.pageData.newAdd_receipt.city = shipping.city
          this.pageData.newAdd_receipt.zipcode = shipping.zipcode
          this.pageData.newAdd_receipt.address = shipping.address
          this.pageData.newAdd_receipt.company = shipping.company
          this.pageData.newAdd_receipt.contacts = shipping.contacts
          this.pageData.newAdd_receipt.tel = shipping.tel
          this.pageData.newAdd_receipt.email = shipping.email
          this.pageData.newAdd_receipt.tag = shipping.tag

          this.pageData.newAdd_receipt.taxno = '-'
          this.addReceiptAddress()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('App.view.order.message_cancel'),
          })
        })
    },
    editShipping(shipping) {
      this.pageData.oldShipping = JSON.parse(JSON.stringify(shipping))

      this.forms.editShipping.id = shipping.id
      this.forms.editShipping.country = shipping.country
      this.forms.editShipping.province = shipping.province
      this.forms.editShipping.city = shipping.city
      this.forms.editShipping.zipcode = shipping.zipcode
      this.forms.editShipping.address = shipping.address
      this.forms.editShipping.company = shipping.company
      this.forms.editShipping.contacts = shipping.contacts
      this.forms.editShipping.tel = shipping.tel
      this.forms.editShipping.email = shipping.email
      this.forms.editShipping.tag = shipping.tag

      this.pageData.editShippingDialogVisible = true
    },
    useJsDoEditReceipt(receipt) {
      centerjs.doEditReceipt(this, receipt).then((val) => {
        if (val) {
          orderconfirmjs.getReceiptAddress(this, this.pageData.username)
        }
      })
    },
    editReceipt(receipt) {
      this.pageData.oldReceipt = JSON.parse(JSON.stringify(receipt))

      this.forms.editReceipt.id = receipt.id
      this.forms.editReceipt.country = receipt.country
      this.forms.editReceipt.province = receipt.province
      this.forms.editReceipt.city = receipt.city
      this.forms.editReceipt.zipcode = receipt.zipcode
      this.forms.editReceipt.address = receipt.address
      this.forms.editReceipt.company = receipt.company
      this.forms.editReceipt.contacts = receipt.contacts
      this.forms.editReceipt.tel = receipt.tel
      this.forms.editReceipt.email = receipt.email
      this.forms.editReceipt.taxno = receipt.taxno
      this.forms.editReceipt.tag = receipt.tag

      this.pageData.editReceiptDialogVisible = true
    },
  },
  components: {
    'com-head': Head,
    'com-foot': Foot,
  },
}
</script>

<style scoped>
.main_wrap {
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  /* position: fixed;
  overflow-x: auto; */
}

.body_wrap {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.orderconfirm_collapse {
  width: 110rem;
}

.shipping_address {
  margin: 0 auto;
}

.receipt_address {
  margin: 0 auto;
}

.address_title {
  text-align: left;
  margin-left: 6rem;
}

.address_title span {
  font-size: 1.3rem;
  font-weight: bold;
  color: #606266;
}

.address_no_result {
  font-size: 1.4rem;
  color: #606266;
  text-align: left;
  margin-left: 10rem;
  margin-top: 2rem;
}

.address_body {
  text-align: left;
  margin-left: 10rem;
  margin-top: 3rem;
  overflow: auto;
}

.div_address {
  margin-bottom: 1.5rem;
}

.address_add {
  text-align: left;
  margin-left: 10rem;
  margin-top: 1rem;
  height: 100%;
}

.address_link {
  color: #409eff;
  font-size: 0.9rem;
}

.address_link:hover {
  color: #96caff;
}

.content_newaddress {
  height: 100%;
}

.col_newitems0 {
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #606266;
  width: 12rem;
}

.col_newitems1 {
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #606266;
  width: 27.5rem;
}

.col_newitems2 {
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #606266;
  width: 27.5rem;
}

.col_newitems_add {
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #606266;
  width: 40.5rem;
}

.col_btn {
  margin-top: 1rem;
  margin-bottom: 2rem;
}

.delivery_items {
  text-align: left;
  margin-top: 1rem;
  margin-left: 10rem;
}

.payment_items {
  text-align: left;
  margin-top: 1rem;
  margin-left: 10rem;
  color: #606266;
  font-size: 1rem;
}

.details_table,
.details_notes {
  margin: 0 auto;
  width: auto;
  margin-left: 10rem;
}

.details_customerpo {
  margin: 0 auto;
  width: 15rem;
  margin-left: 10rem;
}

.details_table .el-image {
  width: 5rem;
}

.details_domain {
  padding: 1rem;
  font-size: 1.3rem;
  color: #606266;
  text-align: left;
  width: 20rem;
  margin-left: 9rem;
}

.question_style {
  color: #000;
  font-size: 1.1rem;
}

.why_style {
  color: #f56c6c;
  font-size: 1rem;
}

.questionnaire_content .el-radio {
  display: block;
  line-height: 2rem;
  white-space: normal;
  /* margin-right: 0; */
}

.addAddressBtn {
  float: right;
  margin-top: 1rem;
}

.el-tag {
  margin-left: 1rem;
}

.step_description {
  position: relative;
  top: -70px;
  font-size: 14px;
}

.step_icon {
  font-size: 19px;
}

.step_title {
  font-size: 14px;
  height: 25px;
  line-height: 25px;
}

/deep/ .el-step__icon.is-icon {
  width: 20px;
}

/deep/ .el-table .cell {
  overflow: visible;
}

/deep/ .el-steps--horizontal {
  margin-top: 20px;
  height: 50px;
}

/deep/ .el-steps .is-wait {
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/views/customer/OrderConfirm.vue